import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

const PRTaskGroup = () => {
  const [teamData, setTeamData] = useState({});
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch('/content/team.json')
      .then(res => res.json())
      .then(data => {
        setTeamData(data);
        setLoading(false);
      })
      .catch(error => {
        console.error('Error loading team data:', error);
        setLoading(false);
      });
  }, []);

  // Filter members who are in PR Task Group
  const getTaskGroupMembers = () => {
    if (!teamData.boardMembers) return [];
    
    const members = teamData.boardMembers.filter(member => 
      member.taskGroups && member.taskGroups.includes('PR Task Group')
    );
    
    // Sort so Dragana Knezić comes first as Secretary/PR
    return members.sort((a, b) => {
      if (a.role === 'Secretary/PR') return -1;
      if (b.role === 'Secretary/PR') return 1;
      return 0;
    });
  };

  const memberCardStyle = {
    backgroundColor: '#ffffff',
    padding: '1.5rem',
    borderRadius: '12px',
    border: '1px solid #e5e7eb',
    boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)',
    textAlign: 'center',
    transition: 'all 0.3s ease'
  };

  const sectionStyle = {
    marginBottom: '3rem',
    padding: '2rem',
    backgroundColor: '#f8fafc',
    borderRadius: '16px',
    border: '1px solid #e2e8f0'
  };

  const activityCardStyle = {
    backgroundColor: '#ffffff',
    padding: '1.5rem',
    borderRadius: '12px',
    border: '1px solid #e5e7eb',
    boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)',
    marginBottom: '1.5rem'
  };

  return (
    <div className="container" style={{maxWidth: '1200px', margin: '0 auto', padding: '2rem'}}>
      {/* Header */}
      <div style={{textAlign: 'center', marginBottom: '3rem'}}>
        <Link 
          to="/task-groups" 
          style={{
            display: 'inline-flex',
            alignItems: 'center',
            color: '#2563eb',
            textDecoration: 'none',
            marginBottom: '1rem',
            fontSize: '1rem'
          }}
        >
          ← Back to Task Groups
        </Link>
        <h1 className="page-title" style={{fontSize: '2.5rem', fontWeight: 'bold', color: '#1e293b', marginBottom: '1rem'}}>
          📢 PR Task Group
        </h1>
        <p className="page-subtitle" style={{fontSize: '1.2rem', color: '#64748b', maxWidth: '800px', margin: '0 auto'}}>
          Promoting Solution Focused Therapy and EBTA through digital communications and outreach
        </p>
      </div>

      {/* Mission */}
      <div style={sectionStyle}>
        <div style={{display: 'flex', alignItems: 'center', marginBottom: '1.5rem'}}>
          <div style={{fontSize: '2rem', marginRight: '1rem'}}>🎯</div>
          <h2 style={{fontSize: '1.8rem', fontWeight: 'bold', color: '#1e293b', margin: 0}}>Our Mission</h2>
        </div>
        <p style={{color: '#64748b', fontSize: '1.1rem', lineHeight: '1.6', marginBottom: '1.5rem'}}>
          This Task Group works on promoting Solution Focused Therapy (SFT) and Solution Focused Approach (SFA), 
          and also promotes EBTA through the Internet, including our Facebook page.
        </p>
        <p style={{color: '#64748b', fontSize: '1.1rem', lineHeight: '1.6'}}>
          We manage digital communications, create engaging content, and maintain EBTA's online presence 
          to reach practitioners and enthusiasts worldwide.
        </p>
      </div>

      {/* Activities */}
      <div style={sectionStyle}>
        <div style={{display: 'flex', alignItems: 'center', marginBottom: '2rem'}}>
          <div style={{fontSize: '2rem', marginRight: '1rem'}}>⚡</div>
          <h2 style={{fontSize: '1.8rem', fontWeight: 'bold', color: '#1e293b', margin: 0}}>Our Activities</h2>
        </div>
        
        <div style={{display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(350px, 1fr))', gap: '1.5rem'}}>
          
          {/* Website Management */}
          <div style={{...activityCardStyle, backgroundColor: '#f0f9ff', border: '1px solid #bfdbfe'}}>
            <div style={{display: 'flex', alignItems: 'center', marginBottom: '1rem'}}>
              <div style={{fontSize: '2rem', marginRight: '1rem', color: '#2563eb'}}>🌐</div>
              <h4 style={{color: '#1e40af', fontSize: '1.3rem', fontWeight: '600', margin: 0}}>Website Management</h4>
            </div>
            <p style={{color: '#6b7280', fontSize: '1rem', lineHeight: '1.6'}}>
              Managing and updating the EBTA website content, ensuring information is current, 
              accessible, and engaging for our global community of practitioners.
            </p>
          </div>

          {/* Social Media */}
          <div style={{...activityCardStyle, backgroundColor: '#fef3c7', border: '1px solid #fde047'}}>
            <div style={{display: 'flex', alignItems: 'center', marginBottom: '1rem'}}>
              <div style={{fontSize: '2rem', marginRight: '1rem', color: '#d97706'}}>📱</div>
              <h4 style={{color: '#a16207', fontSize: '1.3rem', fontWeight: '600', margin: 0}}>Social Media</h4>
            </div>
            <p style={{color: '#6b7280', fontSize: '1rem', lineHeight: '1.6'}}>
              Creating and managing content for EBTA's Facebook page and other social media platforms 
              to engage with the solution-focused community worldwide.
            </p>
          </div>

          {/* Newsletter */}
          <div style={{...activityCardStyle, backgroundColor: '#f0fdf4', border: '1px solid #bbf7d0'}}>
            <div style={{display: 'flex', alignItems: 'center', marginBottom: '1rem'}}>
              <div style={{fontSize: '2rem', marginRight: '1rem', color: '#059669'}}>📧</div>
              <h4 style={{color: '#166534', fontSize: '1.3rem', fontWeight: '600', margin: 0}}>EBTA Newsletter</h4>
            </div>
            <p style={{color: '#6b7280', fontSize: '1rem', lineHeight: '1.6'}}>
              Producing and distributing the EBTA Newsletter to keep members informed about 
              conferences, research, developments, and community news.
            </p>
          </div>

          {/* Digital Outreach */}
          <div style={{...activityCardStyle, backgroundColor: '#fdf4ff', border: '1px solid #e9d5ff'}}>
            <div style={{display: 'flex', alignItems: 'center', marginBottom: '1rem'}}>
              <div style={{fontSize: '2rem', marginRight: '1rem', color: '#7c2d12'}}>📡</div>
              <h4 style={{color: '#7c2d12', fontSize: '1.3rem', fontWeight: '600', margin: 0}}>Digital Outreach</h4>
            </div>
            <p style={{color: '#6b7280', fontSize: '1rem', lineHeight: '1.6'}}>
              Promoting Solution Focused approaches through various digital channels, 
              reaching new audiences and expanding awareness of EBTA's work.
            </p>
          </div>
        </div>
      </div>

      {/* Contact Areas */}
      <div style={{...sectionStyle, backgroundColor: '#f0fdf4', border: '1px solid #bbf7d0'}}>
        <div style={{display: 'flex', alignItems: 'center', marginBottom: '2rem'}}>
          <div style={{fontSize: '2rem', marginRight: '1rem', color: '#059669'}}>📞</div>
          <h2 style={{fontSize: '1.8rem', fontWeight: 'bold', color: '#166534', margin: 0}}>Contact Areas</h2>
        </div>
        
        <div style={{display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: '1.5rem'}}>
          
          {/* Website Content */}
          <div style={{...activityCardStyle, backgroundColor: '#dcfce7', border: '1px solid #bbf7d0'}}>
            <div style={{display: 'flex', alignItems: 'center', marginBottom: '1rem'}}>
              <div style={{fontSize: '2rem', marginRight: '1rem', color: '#059669'}}>🌐</div>
              <h4 style={{color: '#166534', fontSize: '1.2rem', fontWeight: '600', margin: 0}}>Website Content & Newsletter</h4>
            </div>
            <p style={{color: '#166534', fontSize: '1rem', lineHeight: '1.6', marginBottom: '1rem'}}>
              <strong>Dragana Knezić</strong>
            </p>
            <p style={{color: '#6b7280', fontSize: '0.9rem', lineHeight: '1.6'}}>
              For website content and issues connected with the EBTA Newsletter
            </p>
          </div>

          {/* Facebook Content */}
          <div style={{...activityCardStyle, backgroundColor: '#dcfce7', border: '1px solid #bbf7d0'}}>
            <div style={{display: 'flex', alignItems: 'center', marginBottom: '1rem'}}>
              <div style={{fontSize: '2rem', marginRight: '1rem', color: '#059669'}}>📱</div>
              <h4 style={{color: '#166534', fontSize: '1.2rem', fontWeight: '600', margin: 0}}>Facebook Content</h4>
            </div>
            <p style={{color: '#166534', fontSize: '1rem', lineHeight: '1.6', marginBottom: '1rem'}}>
              <strong>Tara Gretton and Naomi Whitehead</strong>
            </p>
            <p style={{color: '#6b7280', fontSize: '0.9rem', lineHeight: '1.6'}}>
              For Facebook content and social media management
            </p>
          </div>

          {/* Website Content */}
          <div style={{...activityCardStyle, backgroundColor: '#dcfce7', border: '1px solid #bbf7d0'}}>
            <div style={{display: 'flex', alignItems: 'center', marginBottom: '1rem'}}>
              <div style={{fontSize: '2rem', marginRight: '1rem', color: '#059669'}}>📝</div>
              <h4 style={{color: '#166534', fontSize: '1.2rem', fontWeight: '600', margin: 0}}>Website Content</h4>
            </div>
            <p style={{color: '#166534', fontSize: '1rem', lineHeight: '1.6', marginBottom: '1rem'}}>
              <strong>Tomasz Świtek</strong>
            </p>
            <p style={{color: '#6b7280', fontSize: '0.9rem', lineHeight: '1.6'}}>
              For content of our website
            </p>
          </div>

          {/* Technical Issues */}
          <div style={{...activityCardStyle, backgroundColor: '#dcfce7', border: '1px solid #bbf7d0'}}>
            <div style={{display: 'flex', alignItems: 'center', marginBottom: '1rem'}}>
              <div style={{fontSize: '2rem', marginRight: '1rem', color: '#059669'}}>🔧</div>
              <h4 style={{color: '#166534', fontSize: '1.2rem', fontWeight: '600', margin: 0}}>Technical Issues</h4>
            </div>
            <p style={{color: '#166534', fontSize: '1rem', lineHeight: '1.6', marginBottom: '1rem'}}>
              <strong>Sander Schieving</strong>
            </p>
            <p style={{color: '#6b7280', fontSize: '0.9rem', lineHeight: '1.6'}}>
              For technical issues concerning the EBTA Website
            </p>
          </div>
        </div>
      </div>

      {/* Members */}
      <div style={sectionStyle}>
        <div style={{display: 'flex', alignItems: 'center', marginBottom: '2rem'}}>
          <div style={{fontSize: '2rem', marginRight: '1rem'}}>👥</div>
          <h2 style={{fontSize: '1.8rem', fontWeight: 'bold', color: '#1e293b', margin: 0}}>Task Group Members</h2>
        </div>
        
        {loading ? (
          <div style={{textAlign: 'center', padding: '2rem'}}>
            <p style={{color: '#6b7280', fontSize: '1.1rem'}}>Loading team members...</p>
          </div>
        ) : (
          <div style={{display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '1.5rem'}}>
            {getTaskGroupMembers().map((member, index) => (
              <div key={index} style={memberCardStyle}>
                <div style={{
                  width: '120px',
                  height: '120px',
                  borderRadius: '50%',
                  backgroundColor: '#f3f4f6',
                  margin: '0 auto 1rem',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  fontSize: '3rem',
                  color: '#6b7280',
                  backgroundImage: member.image ? `url(${member.image})` : 'none',
                  backgroundSize: 'cover',
                  backgroundPosition: 'center'
                }}>
                  {!member.image && '👤'}
                </div>
                <h3 style={{color: '#1e293b', fontSize: '1.3rem', fontWeight: '600', marginBottom: '1rem'}}>
                  {member.name}
                </h3>
              </div>
            ))}
          </div>
        )}
      </div>

      {/* Contact & Support */}
      <div style={{...sectionStyle, backgroundColor: '#f1f5f9', textAlign: 'center'}}>
        <div style={{display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: '1.5rem'}}>
          <div style={{fontSize: '2rem', marginRight: '1rem'}}>📧</div>
          <h2 style={{fontSize: '1.8rem', fontWeight: 'bold', color: '#1e293b', margin: 0}}>Get Involved</h2>
        </div>
        <p style={{fontSize: '1.1rem', color: '#64748b', marginBottom: '1.5rem', maxWidth: '600px', margin: '0 auto 1.5rem'}}>
          Interested in helping with EBTA's communications and outreach?
        </p>
        <p style={{fontSize: '1rem', color: '#64748b', marginBottom: '2rem'}}>
          Contact our PR Task Group to learn about opportunities to contribute to our digital presence.
        </p>
        <div style={{display: 'flex', gap: '1rem', flexWrap: 'wrap', justifyContent: 'center'}}>
          <Link 
            to="/contact"
            style={{
              display: 'inline-flex',
              alignItems: 'center',
              backgroundColor: '#2563eb',
              color: 'white',
              padding: '1rem 2rem',
              borderRadius: '10px',
              textDecoration: 'none',
              fontWeight: '600',
              fontSize: '1rem',
              boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)',
              transition: 'all 0.3s ease'
            }}
            onMouseEnter={(e) => {
              e.target.style.backgroundColor = '#1d4ed8';
              e.target.style.transform = 'translateY(-2px)';
              e.target.style.boxShadow = '0 10px 15px -3px rgba(0, 0, 0, 0.1)';
            }}
            onMouseLeave={(e) => {
              e.target.style.backgroundColor = '#2563eb';
              e.target.style.transform = 'translateY(0)';
              e.target.style.boxShadow = '0 4px 6px -1px rgba(0, 0, 0, 0.1)';
            }}
          >
            <span style={{marginRight: '0.5rem'}}>📧</span>
            Contact Us
          </Link>
          <a 
            href="https://www.facebook.com/EBTA.eu"
            target="_blank"
            rel="noopener noreferrer"
            style={{
              display: 'inline-flex',
              alignItems: 'center',
              backgroundColor: '#059669',
              color: 'white',
              padding: '1rem 2rem',
              borderRadius: '10px',
              textDecoration: 'none',
              fontWeight: '600',
              fontSize: '1rem',
              boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)',
              transition: 'all 0.3s ease'
            }}
            onMouseEnter={(e) => {
              e.target.style.backgroundColor = '#047857';
              e.target.style.transform = 'translateY(-2px)';
              e.target.style.boxShadow = '0 10px 15px -3px rgba(0, 0, 0, 0.1)';
            }}
            onMouseLeave={(e) => {
              e.target.style.backgroundColor = '#059669';
              e.target.style.transform = 'translateY(0)';
              e.target.style.boxShadow = '0 4px 6px -1px rgba(0, 0, 0, 0.1)';
            }}
          >
            <span style={{marginRight: '0.5rem'}}>📱</span>
            Follow on Facebook
          </a>
        </div>
      </div>
    </div>
  );
};

export default PRTaskGroup;
